import { Typography } from "antd"
import { Uuid } from "types"

export const RecordValueCell = ({ value }: { value: Record<Uuid, string> }) => {
    if (typeof value !== "object") return null

    return <Typography.Text>{Object.values(value)[0]}</Typography.Text>
}
